(async () => {
    const { Core } = await importModule('Core');
    const { $hide, $show } = await importModule('Utils');

    customElements.define('products-counter', class extends Core {
        
        subscriptions = {
            'buyWith:change':  '_updateCounter'
        }

        render() {
            this.count = 1;
            this.subscribe('buyWith:change');
        }
        
        _updateCounter({ selected }) {
            selected ? this.count++ : this.count--;
            if (this.count > 1) {
                $show(this);
                this.textContent = this.count;
                return
            } 
            $hide(this); 
        }
    })
})();